import { MobileOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';

import { FormGroup } from 'components';
import { FormGroupItem } from 'components/FormGroupItem';

import { styled } from 'theme';
import type { Firebase } from 'types/firebase';
import { getOptionValueText } from 'utils/OptionUtils';
import { NOTES_FEATURE, QR_PAYMENT_FEATURE } from '../../../../constants';
/**
 * Styling
 */
const Container = styled.div``;

/**
 * Types
 */
export type MerchantConfigurationProps = {
  merchant: Firebase.Merchant;
  onSave: (name: string, value: string | number) => void;
};

type FormFieldType = {
  title: string;
  icon: React.ReactNode;
  inputs: {
    type?: string;
    label: string;
    alternativeLabel: string;
    name: string;
    value: string | number | null;
  }[];
};

/**
 * MerchantConfiguration component
 */
const MerchantConfiguration: React.FC<MerchantConfigurationProps> = (props) => {
  const { merchant } = props;
  // Notes
  const hasNotes =
    merchant?.configuration === 'notes' ||
    merchant?.configuration?.includes('notes');
  const hasNotesValue = hasNotes ? 'enable_notes' : 'disable_notes';
  const notesValueText = getOptionValueText(NOTES_FEATURE, hasNotesValue);
  // qrPayment
  const hasQrPayments =
    merchant?.configuration === 'qrPayment' ||
    merchant?.configuration?.includes('qrPayment');
  const hasQrPaymentsValue = hasQrPayments
    ? 'enable_qrPayment'
    : 'disable_qrPayment';
  const qrPaymentsValueText = getOptionValueText(
    QR_PAYMENT_FEATURE,
    hasQrPaymentsValue,
  );
  // @ts-ignore
  const formFields = useMemo<FormFieldType[]>(() => {
    return [
      {
        title: 'App Feature Configurations',
        icon: <MobileOutlined />,
        inputs: [
          {
            type: 'dropdown',
            label: 'Notes (App)',
            alternativeLabel: 'Notes',
            name: 'configuration',
            value: notesValueText,
            dropdown: {
              placeholder: 'Select a type',
              values: NOTES_FEATURE,
              options: NOTES_FEATURE,
            },
          },
          {
            type: 'dropdown',
            label: 'QR Payments (App)',
            alternativeLabel: 'QR Payments',
            name: 'configuration',
            value: qrPaymentsValueText,
            dropdown: {
              placeholder: 'Select a type',
              values: QR_PAYMENT_FEATURE,
              options: QR_PAYMENT_FEATURE,
            },
          },
        ],
      },
    ];
  }, [merchant]);

  const _onHandleSave = (fieldName: string, newValue: string) => {
    const dataType = typeof merchant?.configuration;
    const updateType = newValue.split('_')[0] as 'enable' | 'disable';
    const featureType = newValue.split('_')[1];
    // Is array
    if (dataType === 'object') {
      // is array, just push or pull
      let newArr = [];
      if (updateType === 'disable') {
        // @ts-ignore
        newArr = merchant?.configuration.filter(
          // @ts-ignore
          (feature) => feature !== featureType,
        );
        // @ts-ignore
        props.onSave(fieldName, newArr);
      }
      // Enable
      else {
        // @ts-ignore
        newArr = [...merchant?.configuration, featureType];
        console.log(newArr);
        // @ts-ignore
        props.onSave(fieldName, newArr);
      }
    }
    // is string
    else if (dataType === 'string') {
      if (updateType === 'disable') {
        // @ts-ignore
        props.onSave(fieldName, []);
      }
      // Enable
      else {
        // @ts-ignore
        newArr = [...merchant?.configuration, featureType];
        // @ts-ignore
        console.log(newArr);
        // @ts-ignore
        props.onSave(fieldName, newArr);
      }
    }
    // No current values; just add feature
    else {
      if (updateType === 'disable') {
        // We just add empty array
        // @ts-ignore
        props.onSave(fieldName, []);
      } else {
        // @ts-ignore
        props.onSave(fieldName, [featureType]);
      }
    }
  };

  return (
    <div>
      {formFields.map((form) => (
        <Container key={form.title}>
          <FormGroup icon={form.icon} title={form.title}>
            {form.inputs.map((input) => (
              <FormGroupItem
                {...input}
                key={input.name}
                onSave={(newValue) =>
                  _onHandleSave(input.name, newValue as string)
                }
              />
            ))}
          </FormGroup>
        </Container>
      ))}
    </div>
  );
};

export { MerchantConfiguration };
